import { TweenMax } from 'gsap';

const parent = document.querySelector( '.header-main-logo' );
const images = document.querySelectorAll( '.logo-animation img' );
const imgArray = [...images];

function cycleImages() {
  TweenMax.to( imgArray[0], 0.25, { css: { autoAlpha: 0 } } );
  TweenMax.to( imgArray[1], 0.25, { css: { autoAlpha: 1 } } );
  imgArray.push( imgArray.shift() );
}

function initEvents() {
  let animation = {};

  parent.addEventListener( 'mouseenter', () => {
    animation = setInterval( cycleImages, 250 );
  } );

  parent.addEventListener( 'mouseleave', () => {
    clearInterval( animation );
  } );
}

function init() {
  initEvents();
}

export default {
  init,
};
